<!-- 场地及视频播放地址切换组件 -->
<template>
    <div class="video-src-switch"
         v-if="showSrcSwitch && videoSwitchData.length >0"
         :style="{width:switchMoreInfo?'150px':'60px',top:abTop,right:parseInt(abRight)>20?(switchMoreInfo?'20px':'62px'):'20px','background':isIE?'#000000':'transparent'}"  >
      <iframe
              v-if="isIE"
              style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
              allowtransparency="true"
              src=""
              frameborder="0"></iframe>

      <table class="switch—table" v-for="(item,index) in videoSwitchData" :key="index">
        <tr>
          <td class="td-info">{{item.fieldInfo.regionName || '咸宁'}}
            <span v-if="switchMoreInfo"> - {{item.fieldInfo.fieldName}}</span>
          </td>
        </tr>
        <tr v-for="device in item.devices" :key="device.id">
          <td  :class="currentVideoId == device.id?'link active':'link'"
               style="border:none"
               @click="switchVideoSrc(device)">
            <icon-svg name="platform1" v-if="device.deviceType==1" style="font-size: 19px;position: relative;top: 4px"></icon-svg>
            <icon-svg name="camera" v-if="device.deviceType==2" style="font-size: 19px;position: relative;top: 4px"></icon-svg>
            <icon-svg name="camera1" v-if="device.deviceType==3" style="font-size: 19px;position: relative;top: 4px"></icon-svg>
            <span v-if="switchMoreInfo">&nbsp;&nbsp;&nbsp;{{device.deviceName}}</span>
          </td>
        </tr>
        <tr @click="switchMoreInfo=!switchMoreInfo" >
          <td class="td-info">
            <el-button type="text" style="color: #FFFFFF" size="mini" v-if="!switchMoreInfo" > {{leftArrow}} </el-button>
            <el-button type="text" style="color: #FFFFFF" size="mini" v-if="switchMoreInfo" > 收起 {{rightArrow}} </el-button>
          </td>
        </tr>
      </table>
    </div>
</template>
<script>
  import {isIEBrowser} from '@/utils/index';

  export default {
      components: {},
        name: 'placeAndEquipment',
        data() {
            return {
                isIE:false,
                leftArrow:"<<",
                rightArrow:">>",
                currentVideo: {},
                switchMoreInfo:true,
                currentVideoId:"",

            };
        },
        head() {
            return {};
        },
        props: {
            showSrcSwitch:{
              type: Boolean,
              default:false
            },
          abTop:{
            type: String,
            default:'20px'
          },
          abRight:{
            type: String,
            default:'20px'
          },
            showCutScreen:{
              type: Boolean,
              default:false
            },
            roomType:{
              type: String,
              default:''
            },

          videoSwitchData: {
            type: Array,
            default() {
              return [
                // {
                //   fieldInfoResult:{},
                //   devices:[]
                // },
              ];
            },
          },
        },
        watch: {

        },
        filters: {

          formatterRoomType:function(type){
            switch(type){
              case '1':return '-专家抽取室';break;
              case '2':return '-开标见证';break;
              case '3':return '-评标见证';break;
              case '4':return '-实时门禁';break;
              default:return '';break;
            }
          },

        },
      created() {
        this.isIE = isIEBrowser()
      },
      methods: {


          setCurrentVideo(video){

            this.currentVideo = video;
            this.currentVideoId = video.id;

         },


          switchVideoSrc(item){
            this.currentVideo=item;
            this.currentVideoId = item.id;
            this.$emit('switchCurrentVideo', item);
          },

        },
        mounted() {

          this.$nextTick(() => {
         console.log(this.videoSwitchData,'控件页面得数据videoSwitchData是啥');

          })


        },
    };
</script>
<style scoped lang="less">

.video-src-switch{
  position: absolute;
  top: 20px;
  right: 20px;
  z-index:900;
  .switch—table{
    border: 1px solid #1965FF;
    border-collapse:collapse;
    background: rgba(41,98,188,0.85);
    text-align: center;
    tr{
      height: 25px;cursor:pointer;color: #FFFFFF;opacity: 1;
      td{
        line-height: 24px;
        padding: 4px 0px;
      }
      .td-info{
        border: 1px solid #1965FF;
        width: 300px;
        box-shadow:0px 0px 6px #1965FF inset;
        cursor: pointer;
      }
    }


    .link{
      cursor: pointer;
      text-decoration: none;
      color: #FFFFFF;
      opacity: 0.5;

      &.active{
        /*background-color: #1965FF;*/
        /*box-shadow:0px 0px 8px #1965FF inset;*/
        opacity:1;
      }
      &:hover {
        /*background-color: #1965FF;*/
        opacity:1;
      }
    }

  }
}






</style>